<template>
  <div v-if="!loadingLead" class="lead">
    <v-container fluid>
      <v-row>
        <v-col cols="12" lg="6">
          <ClientTab
            :lead="lead"
            :agent="user"
            :baseData="baseData"
            :source="lead.source"
          />
        </v-col>
        <v-col cols="12" lg="6">
          <AgentTab
            :lead="lead"
            :baseData="baseData"
            :agent_id="user.id"
            :source="lead.source"
          />
        </v-col>
      </v-row>
    </v-container>
    <LeadBottomControlPanel
      :lead="lead"
      :user_role_id="user.role_id"
      :baseData="baseData"
    />
    <NecessaryFollowupDialog :lead_id="lead.id" :user_id="user.id" />
  </div>
  <div v-else>
    <v-container>
      <v-row>
        <v-col cols="6">
          <v-skeleton-loader
            class="mx-auto"
            type="image"
            tile="tile"
            v-for="loader in loaders"
            :key="loader"
          />
        </v-col>
        <v-col cols="6">
          <v-skeleton-loader
            class="mx-auto"
            type="image"
            tile="tile"
            v-for="loader in loaders"
            :key="loader"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AgentTab from "@/components/lead/agent/AgentTab";
import ClientTab from "@/components/lead/client/ClientTab";
import LeadBottomControlPanel from "@/components/lead/LeadBottomControlPanel";
import NecessaryFollowupDialog from "@/components/forms/NecessaryFollowupDialog";

export default {
  name: "Lead",
  inject: ["theme"],
  components: {
    AgentTab,
    ClientTab,
    LeadBottomControlPanel,
    NecessaryFollowupDialog,
  },
  data() {
    return {
      lead_id: this.$route.params.lead_id,
      loaders: ["1", "2", "3"],
    };
  },
  created() {
    document.addEventListener("beforeunload", this.unActive);
  },
  methods: {
    ...mapActions({
      loadLead: "lead/loadLead",
      loadFollowups: "followups/loadFollowups",
      loadScripts: "lead/loadScripts",
      loadEmails: "emails/loadEmails",
      loadSetting: "settings/loadSetting",
      loadMessages: "messages/loadMessages",
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
      getCustomersVoiceMails: "voicemails/getCustomersVoiceMails",
    }),
    unActive() {
      this.$socket.emit("unbusy-lead", this.lead_id);
    },
  },
  mounted() {
    this.loadLead(+this.lead_id);
    this.loadEmails(+this.lead_id);
    this.loadMessages(+this.lead_id);
    this.showHandlerSnackbar({
      color: "info",
      text: "Please remember to change the status",
      show: true,
    });
    this.loadSetting();
    this.getCustomersVoiceMails(+this.lead_id);
    this.sockets.subscribe("UPDATE_LEAD", () => {});
    this.$socket.emit("busy-lead", this.lead_id);
    this.sockets.subscribe("RECORD_ADD", () => {});
    this.sockets.subscribe("FOLLOWUP_CREATE", () => {});
    this.sockets.subscribe("FOLLOWUP_UPDATE", () => {});
    this.sockets.subscribe("UPDATE_PREMIUM_CARRIER", () => {});
    this.loadFollowups(+this.lead_id);
  },
  // destroyed() {
  //   this.$socket.emit("unbusy-lead", this.lead_id);
  // },
  computed: {
    ...mapGetters({
      loadingLead: "lead/loadingLead",
      lead: "lead/lead",
      user: "auth/user",
      agents: "agents/suitableAgents",
      baseData: "baseData/baseData",
    }),
  },
};
</script>

<style lang="scss">
.lead {
  position: relative;
  margin-bottom: 80px;
}
</style>
